export enum AdStatusEnum {
  InProgress = 0,
  Won = 1,
  Lost = 2,
}
